import { VirtListRowProps } from "../BaseList";
import { ListWithGroupsRowType } from "./ListGroup";
import * as styles from "./ListGroup.less";

const isGroup = (item: ListWithGroupsRowType): boolean => item.group;
const isFirstItemInGroup = (item: ListWithGroupsRowType, index: number): boolean => index === 0 || isGroup(item);
const isLastItemInGroup = (items: ListWithGroupsRowType[], index: number): boolean =>
    index === items.length - 1 || isGroup(items[index + 1]);
export const addPaddingIf = (condition: boolean): number => (condition ? 8 : 0);

export const groupedListsPaddingClasses = (args: VirtListRowProps<ListWithGroupsRowType>) => {
    const { index, item, items, getItemClassName } = args;

    const classes = [getItemClassName?.(item, items)];

    if (isFirstItemInGroup(item, index)) {
        classes.push(styles.first_item_in_group);
    }
    if (isLastItemInGroup(items, index)) {
        classes.push(styles.last_item_in_group);
    }

    return classes;
};

export const getGroupedListItemHeight =
    <TItem extends ListWithGroupsRowType>(rowHeight?: number) =>
    (item: TItem, index: number, items: TItem[]) => {
        const height = isGroup(item) ? 36 : rowHeight || 28;
        const topPadding = addPaddingIf(isFirstItemInGroup(item, index));
        const bottomPadding = addPaddingIf(isLastItemInGroup(items, index));

        return height + topPadding + bottomPadding;
    };
